"use client";

import { Card } from "@/components/ui/card";
import { Image as ImageIcon } from "lucide-react";

export const HotelCardLoadingSkeleton = () => {
  return (
    <Card className="card w-full p-0 mb-4 rounded-lg shadow overflow-hidden dark:border dark:border-background animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
        <div className="w-full h-55 bg-muted flex items-center justify-center">
          <div className="border border-background rounded-full p-5">
            <ImageIcon className="text-muted-foreground" />
          </div>
        </div>
        <div className="w-full px-4 py-3 flex flex-col justify-between">
          <div>
            <div className="h-6 bg-muted rounded w-1/2"></div>
            <div className="flex items-center gap-2 mt-1">
              <div className="h-4 bg-muted rounded w-1/4"></div>
            </div>
            <div className="mt-2 h-4 bg-muted rounded w-2/3"></div>
            <div className="flex flex-wrap gap-2 items-center mt-4">
              <div className="h-4 bg-muted rounded w-1/3"></div>
            </div>
            <div className="mt-4 h-4 bg-muted rounded w-3/4"></div>
            <div className="mt-4 h-4 bg-muted rounded w-3/4"></div>
          </div>
        </div>
        <div className="w-full bg-primary/10 px-4 py-3">
          <div>
            <div className="h-4 bg-muted rounded w-1/2"></div>
            <div className="h-4 bg-muted rounded w-1/2 mt-2"></div>
            <div className="h-4 bg-muted rounded w-2/3 mt-2"></div>
            <div className="h-10 bg-muted rounded w-full mt-4"></div>
          </div>
        </div>
      </div>
    </Card>
  );
};
